
/**
 * Clase que representa los filtros de consultas de magistrados con su lógica
 */
export default class FiltroMagistrados {
  cuil: number;
  apellido: string;
  
  
  constructor(cuil?: number) {
    this.apellido = undefined as unknown as string;
    this.cuil = cuil ? cuil : undefined as unknown as number;


    

  }

  toQuerystring(): string {
     let query = ''
    const queryParts: any[] = []
    if(this.cuil) queryParts.push(`cuil:${this.cuil}`)
    if(this.apellido) queryParts.push(`apellido:${this.apellido}`)
    
    query = queryParts.length === 0 ? '' :`&query=${queryParts.join()}`
    return query
  }




}
